// extracted by mini-css-extract-plugin
export default {"chart":"pchart_chart__z8wBQ"};